import { useRef, useState, useEffect } from 'preact/hooks'

import Icon from '@/components/snippets/icon/icon'

import { SearchInput } from 'libs/searchspring/components/quick-search/SearchInput'
import { QuickSearchDropdown } from 'libs/searchspring/components/quick-search/QuickSearchDropdown'
import { SearchspringAutocompleteProvider } from 'libs/searchspring/fetchers/autocomplete'

function QuickSearch({ id = 'quick-search' }) {
  const searchInputRef = useRef()
  const [inputValue, setInputValue] = useState()
  const [query, setQuery] = useState()
  const closeButtonRef = useRef()
  const modalRef = useRef()
  const [redirect, setRedirect] = useState(false)

  const handleFocusInput = () => {
    setTimeout(() => {
      searchInputRef.current.focus()
    }, 0)
  }

  const handleClose = (event) => {
    event.preventDefault()
    modalRef.current?.handleHide()
  }

  const handleUpdateValue = (event) => {
    setInputValue(event.target.value)
  }

  const resetInputValue = () => {
    setInputValue('')
    searchInputRef.current.value = ''
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setQuery(inputValue)
    }, 400)
    return () => {
      clearTimeout(timeout)
    }
  }, [inputValue])

  return (
    <x-modal className="group/search flex items-center h-full z-0" data-id={id} data-body-lock ref={modalRef}>
      <button
        className="flex size-[17px] link-fade children:size-full"
        data-modal-parent={id}
        data-modal-role="open"
        onClick={handleFocusInput}
        aria-label="Toggle search"
      >
        <Icon id="magnifying-glass" />
      </button>
      <div
        className="flex flex-col absolute inset-tl w-full h-fit -translate-y-[125%] group-data-visible/search:translate-y-0 z-100 transition-all"
      >
        <form action="/search" method="get" className="shrink-0 flex items-center lg:justify-center gap-x-1 sticky inset-tl w-full h-header px-margin px-6.25 border-b border-neutral-medium bg-secondary">
          <div className="grow lg:max-w-[676px]">
            <div className="field-container field-m w-full">
              <SearchInput ref={searchInputRef} redirect={redirect} onInput={handleUpdateValue} />
              {inputValue ? (
                <button className="field-icon !pointer-events-auto link-fade size-[9px] children:size-full" onClick={resetInputValue} type="reset" aria-label="Clear search">
                  <Icon id="close" />
                </button>
              ) : null}
            </div>
          </div>
          <button
            className="shrink-0 lg:absolute lg:top-1/2 lg:right-margin lg:-translate-y-1/2 btn btn-primary btn-text btn-m"
            data-modal-parent={id}
            data-modal-role="close"
            ref={closeButtonRef}
            onClick={handleClose}
            aria-label="Close modal"
          >
            <span>Close</span>
            <div className="lg-max:hidden size-[11px] children:size-full">
              <Icon id="close" />
            </div>
          </button>
        </form>
        <SearchspringAutocompleteProvider runOnMount={false} resultsPerPage={4}>
          <QuickSearchDropdown query={query} redirect={redirect} setRedirect={setRedirect} />
        </SearchspringAutocompleteProvider>
      </div>
      <button
        className="fixed inset-tl size-full bg-neutral-black/60 opacity-0 group-data-visible/search:opacity-100 pointer-events-none group-data-visible/search:pointer-events-auto cursor-n-resize z-90 transition-all"
        data-modal-parent={id}
        data-modal-role="close"
        aria-label="Close modal"
      ></button>
    </x-modal>
  )
}

export function WrappedQuickSearch({ id }) {
  return (
    <SearchspringAutocompleteProvider runOnMount={false}>
      <QuickSearch id={id} />
    </SearchspringAutocompleteProvider>
  )
}
